import React from 'react';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import ReportErrors from '@atlassian/jira-errors-handling/src/utils/reporting-error-boundary.tsx';
import NonCritical from '@atlassian/jira-non-critical/src/NonCriticalComponent.tsx';
import { UpFlowIFrame } from '@atlassian/jira-up-flow-iframe/src/async.tsx';
import { useUpflowModal } from './controllers/index.tsx';

export const UpflowIframeComponent = () => {
	const [
		{ renderUpflowModal, targetEdition, product, flow, touchpointId, subRoute, onClose, onOpen },
		{ unMountUpflowModal },
	] = useUpflowModal();

	if (!renderUpflowModal) return null;

	const onModalDismissed = () => {
		unMountUpflowModal();
	};

	return (
		<NonCritical>
			<ErrorBoundary id="upflowIframeComponent" packageName="jiraUpflowIframePlugin">
				<ReportErrors id="upflowIframeComponent" packageName="jiraUpflowIframePlugin">
					<UpFlowIFrame
						product={product}
						targetEdition={targetEdition}
						flow={flow}
						touchpointId={touchpointId}
						experienceTrackingEnabled
						onClose={onClose || onModalDismissed}
						subRoute={subRoute}
						onOpen={onOpen || undefined}
					/>
				</ReportErrors>
			</ErrorBoundary>
		</NonCritical>
	);
};
